export default __webpack_public_path__ + "static/media/D_Home_C.75c1a0b5.jpg";